<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Dealer Service</li>
		</ol>

        <h1 class="page-header">Dealer Service</h1>
        <!-- <hr> -->

        <!-- Tabs Start -->
        <div class="mb-4">
          <ul class="nav nav-tabs" style="display: flex; justify-content: space-evenly;">
            <li class="nav-item" v-for="(tabName, index) in tabs">
              <a
                class="nav-link"
                :class="{
                  'active' : tab == index,
                  'clickAble' : tab != index
                }"
                @click="tab = index"
              >{{ tabName }}</a>
            </li>
          </ul>
        </div>
        <!-- Tabs End -->
    
        <!-- Tabs Content Start -->
        <service-overview
          v-if="tab == 0"
          :filter="filter.serviceOverview"
          :data="data.serviceOverview"
          @newDateRange="newDateRange"
        ></service-overview>
    
        <service-operation
          v-if="tab == 1"
          :filter="filter.serviceOperation"
          :data="data.serviceOperation"
          :periodFilter="periodFilter.serviceOperation"
          @newDateRange="newDateRange"
        ></service-operation>
        <!-- Tabs Content End -->
    </div>
</template>

<script>
    import qs from 'qs'
    import moment from 'moment'

    import serviceOverview from './tabs/serviceOverview';
    import serviceOperation from './tabs/serviceOperation';

    export default {
        data () {
            return {
                tab : 0,
                tabs : ['Service Overview', 'Service Operation'],
                periodFilter : {
                    serviceOverview : {},
                    serviceOperation : {}
                },
                prevFilter : {
                    serviceOverview : {},
                    serviceOperation : {}
                },
                filter : {
                    serviceOverview : {
                        overview : {},
                        analysis : {
                            region : null,
                            dealer : null
                        },
                        region : {
                            flag : 'REGION',
                        },
                        model : {
                            region : null,
                            dealer : null,
                        },
                        productionYear : {
                            region : null,
                            dealer : null,
                            model : null
                        },
                        color : {
                            region : null,
                            dealer : null,
                            model : null
                        }
                    },
                    serviceOperation : {
                        'unit-by-pkb' : {},
                        'pkb-details' : {
                            region : null,
                            dealer : null
                        },
                        'customer-location' : {
                            flag : 'REGION',
                        },
                        'by-insurance' : {
                            region : null,
                            dealer : null
                        },
                        'damage-type' : {
                            region : null,
                            dealer : null,
                        },
                        'qr-register' : {
                            region : null,
                            dealer : null
                        }
                    }
                },
                data : {
                    serviceOverview : {
                        overview : null,
                        analysis : null,
                        region : null,
                        model : null,
                        productionYear : null,
                        color : null
                    },
                    serviceOperation : {
                        'unit-by-pkb' : null,
                        'pkb-details' : null,
                        'customer-location' : null,
                        'by-insurance' : null,
                        'damage-type' : null,
                        'qr-register' : null,
                    }
                }
            }
        },
        components : {
            serviceOverview,
            serviceOperation,
        },
        async mounted () {
            await this.resetOperations();
            this.fetchData();
        },
        watch : {
            //PERIOD FILTER
            'periodFilter.serviceOverview' : {
                deep : true,
                handler () {
                    // console.log('hi')
                    this.fetchData('serviceOverview')
                }
            },
            'periodFilter.serviceOperation' : {
                deep : true,
                handler () {this.fetchData('serviceOperation')}
            },

            //INDIVIDUAL FILTERS
            //Service Overview
            'filter.serviceOverview' : {
                deep : true,
                handler (val) {
                    for (var i in val) {
                        if (JSON.stringify(val[i]) !== JSON.stringify(this.prevFilter.serviceOverview[i]))
                            this.fetchData('serviceOverview', i);
                    }

                    this.prevFilter.serviceOverview = JSON.parse(JSON.stringify(this.filter.serviceOverview))
                }
            },
            //Service Operation
            'filter.serviceOperation' : {
                deep : true,
                handler (val) {
                    for (var i in val) {
                        if (JSON.stringify(val[i]) !== JSON.stringify(this.prevFilter.serviceOperation[i]))
                            this.fetchData('serviceOperation', i);
                    }

                    this.prevFilter.serviceOperation = JSON.parse(JSON.stringify(this.filter.serviceOperation))
                }
            }
        },
        methods : {
            newDateRange (group, obj) {
                this.periodFilter[group] = obj;

                for (var i in this.filter) {
                    for (var j in this.filter[i]) {
                        this.filter[i][j].start = obj.start;
                        this.filter[i][j].end = obj.end;
                        this.filter[i][j].period = obj.period;
                        console.log(obj)
                    }
                }
            },
            resetOperations () {
                //Set Date Ranges
                let start = moment().startOf('month').format('YYYY-MM-DD 00:00:00')
                let end = moment().format('YYYY-MM-DD 23:59:59')
                let period = 1

                for (var i in this.periodFilter) {
                    this.periodFilter[i].start = start;
                    this.periodFilter[i].end = end;
                    this.periodFilter[i].period = period
                    
                    
                }

                for (var i in this.filter) {
                    for (var j in this.filter[i]) {
                        this.filter[i][j].start = start;
                        this.filter[i][j].end = end;
                        this.filter[i][j].period = period
                        
                    }
                }

                for (var i in this.filter) {
                    this.prevFilter[i] = JSON.parse(JSON.stringify(this.filter[i]));
                }
            },
            async fetchData (group, subGroup) {
                var list = {}
                if(group) list = {group:subGroup?[subGroup]:Object.keys(this.data[group])}
                else {
                    var keys = Object.keys(this.data)
                    for(var i in keys) list[keys[i]] = Object.keys(this.data[keys[i]]);
                }

                for (var i in list){//stock overview, stock operation
                    for (var j in list[i]){//real url
                        let groupA = group?group:i
                        let listA = list[i][j]
                        this.data[groupA][listA]  = null
                        this.$http.get(`/api/service/${listA}${qs.stringify(this.filter[groupA][listA], {skipNulls:true, addQueryPrefix:true})}`)
                        .then((resp)=>{
                            this.data[groupA][listA] = resp.data.data;
                        })
                        .catch((err)=>{console.log(err)})
                    }
                }
            },
        }
    }
</script>

<style>
  .astraColorButton {
    background: #09549F;
    color: white;
    border: 1px solid #09549F;
    height: 43px;
    width:100%;
  }
  
  .astraColorButtonOutline {
    background: white;
    color: #09549F;
    border: 1px solid #09549F;
    height: 43px;
    width:100%;
  }

  .dealerService .multiselect__tags  {
    background-color: #09549F !important;
  }

  .dealerService .multiselect__single , .dealerService .multiselect__input , .dealerService .multiselect__input::placeholder , .dealerService .multiselect__placeholder {
    background-color: #09549F !important;
    color: white;
  }
  
  .dealerService .multiselect__select:before{
    color: white !important;
  }

  .dealerService.disabledButton .multiselect__select {
    background-color: #09549F
  }
</style>

<style scoped>
  .nav-tabs, .nav-link{
    border:1px solid transparent !important;
  }
  .nav-tabs {
    border-bottom: 1px solid #dee2e6 !important;
  }
  .nav-link{
    border:1px solid !important;
    border-color: #dee2e6 #dee2e6 #fff #dee2e6 !important;
  }
  .nav-link.active{
    border-color:#dee2e5 #dee2e6 #fff !important;
    background-color:#F5F5F5;
  }

  .nav-item {
    width:50%;
    text-align: center;
  }
  .clickAble:hover{
    cursor:pointer;
  }
</style>